// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2jI6H","content":"Consent_content__8WujX","footer":"Consent_footer__1wsgS"};